// 由 EB view/admin/src/router/modules/marketing.js 转换
// 已存在 views 的路由启用；暂无页面的路由整段注释，迁移后取消注释即可
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import ParentView from '@/components/ParentView/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

const marketingRouter: RouteRecordRaw = {
  path: `${roterPre}/marketing`,
  name: 'marketing',
  meta: {
    title: '营销',
  },
  alwaysShow: true,
  component: Layout,
  redirect: 'noRedirect',
  children: [
    {
      path: 'coupon',
      name: 'Coupon',
      meta: {
        title: '优惠券',
        noCache: true,
      },
      component: ParentView,
      redirect: `${roterPre}/marketing/coupon/list`,
      children: [
        {
          path: 'list',
          name: 'CouponList',
          meta: {
            title: '店铺优惠劵列表',
            noCache: true,
          },
          component: () => import('@/views/marketing/coupon/couponList/index.vue'),
        },
        {
          path: 'user',
          name: 'CouponUser',
          meta: {
            title: '会员领取记录',
            noCache: true,
          },
          component: () => import('@/views/marketing/coupon/couponUser/index.vue'),
        },
      ],
    },
    {
      path: 'platform_coupon',
      name: 'PlatformCoupon',
      meta: {
        title: '平台优惠券',
        noCache: true,
      },
      component: ParentView,
      redirect: `${roterPre}/marketing/platform_coupon/list`,
      children: [
        {
          path: 'list',
          name: 'PlatformCouponlist',
          meta: {
            title: '平台优惠劵列表',
            noCache: true,
            activeMenu: `${roterPre}/marketing/platform_coupon/list`,
          },
          component: () => import('@/views/marketing/platformCoupon/couponList/index.vue'),
        },
        {
          path: 'couponRecord',
          name: 'CouponRecord',
          meta: {
            title: '优惠劵领取记录',
            noCache: true,
            activeMenu: `${roterPre}/marketing/platform_coupon/couponRecord`,
          },
          component: () => import('@/views/marketing/platformCoupon/couponRecord/index.vue'),
        },
        {
          path: 'creatCoupon/:id?',
          name: 'CreatCoupon',
          meta: {
            title: '添加优惠劵',
            noCache: true,
            activeMenu: `${roterPre}/marketing/platform_coupon/list`,
          },
          component: () => import('@/views/marketing/platformCoupon/couponList/creatCoupon.vue'),
        },
        {
          path: 'couponSend',
          name: 'CouponSend',
          meta: {
            title: '优惠券发送记录',
            noCache: true,
            activeMenu: `${roterPre}/marketing/platform_coupon/couponSend`,
          },
          component: () => import('@/views/marketing/platformCoupon/couponSend/index.vue'),
        },
        {
          path: 'instructions',
          name: 'Instructions',
          meta: {
            title: '使用说明',
            noCache: true,
            activeMenu: `${roterPre}/marketing/platform_coupon/instructions`,
          },
          component: () => import('@/views/marketing/platformCoupon/couponInstructions/index.vue'),
        },
      ],
    },
    // {
    //   path: 'studio',
    //   name: 'Studio',
    //   meta: {
    //     title: '直播间',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'StudioList',
    //       meta: {
    //         title: '直播间列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/studio/studioList/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'broadcast',
    //   name: 'Broadcast',
    //   meta: {
    //     title: '直播',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'BroadcastList',
    //       meta: {
    //         title: '直播商品列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/broadcast/broadcastList/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'seckill',
    //   name: 'Seckill',
    //   meta: {
    //     title: '秒杀管理',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'seckillConfig',
    //       name: 'SeckillConfig',
    //       meta: {
    //         title: '秒杀配置',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/seckill/seckillConfig/index.vue'),
    //     },
    //     {
    //       path: 'list',
    //       name: 'SpikeList',
    //       meta: {
    //         title: '秒杀商品',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/seckill/seckillGoods/index.vue'),
    //     },
    //     {
    //       path: 'store_seckill/list',
    //       name: 'SeckillActivity',
    //       meta: {
    //         title: '秒杀活动',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/seckill/store_seckill/index.vue'),
    //     },
    //     {
    //       path: 'store_seckill/create/:id?/:type?',
    //       name: 'CreateSeckillActivity',
    //       meta: {
    //         title: '创建秒杀活动',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/seckill/store_seckill/list`,
    //       },
    //       component: () => import('@/views/marketing/seckill/store_seckill/create.vue'),
    //     },
    //     {
    //       path: 'store_seckill/statistics/:id?',
    //       name: 'SeckillStatistics',
    //       meta: {
    //         title: '秒杀活动统计',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/seckill/store_seckill/list`,
    //       },
    //       component: () => import('@/views/marketing/seckill/store_seckill/statistics.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'presell',
    //   name: 'preSell',
    //   meta: {
    //     title: '预售商品管理',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'preSaleList',
    //       meta: {
    //         title: '预售商品',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/preSale/index.vue'),
    //     },
    //     {
    //       path: 'agreement',
    //       name: 'preSaleAgreement',
    //       meta: {
    //         title: '预售协议',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/preSale/agreement.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'assist',
    //   name: 'assist',
    //   meta: {
    //     title: '助力活动商品',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'goods_list',
    //       name: 'assistProductList',
    //       meta: {
    //         title: '助力活动商品',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/assist/assist_goods/index.vue'),
    //     },
    //     {
    //       path: 'list',
    //       name: 'assistList',
    //       meta: {
    //         title: '助力活动列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/assist/assist_list/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'combination',
    //   name: 'combinAtion',
    //   meta: {
    //     title: '拼团',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'combination_goods',
    //       name: 'combinationGoods',
    //       meta: {
    //         title: '拼团商品',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/combination/combination_goods/index.vue'),
    //     },
    //     {
    //       path: 'combination_list',
    //       name: 'combinationList',
    //       meta: {
    //         title: '拼团活动',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/combination/store_combination/index.vue'),
    //     },
    //     {
    //       path: 'combination_set',
    //       name: 'combinationSet',
    //       meta: {
    //         title: '拼团设置',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/combination/combination_set/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'integral',
    //   name: 'Integral',
    //   meta: {
    //     title: '积分',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'config',
    //       name: 'integralConfig',
    //       meta: {
    //         title: '积分配置',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/config/index.vue'),
    //     },
    //     {
    //       path: 'log',
    //       name: 'integralLog',
    //       meta: {
    //         title: '积分日志',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/log/index.vue'),
    //     },
    //     {
    //       path: 'classify',
    //       name: 'integralClassify',
    //       meta: {
    //         title: '积分商品分类',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/classify/index.vue'),
    //     },
    //     {
    //       path: 'proList',
    //       name: 'integralProductList',
    //       meta: {
    //         title: '积分商品列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/productList/index.vue'),
    //     },
    //     {
    //       path: 'addProduct/:id?/:edit?',
    //       name: 'addIntegralProduct',
    //       meta: {
    //         title: '添加积分商品',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/integral/proList`,
    //       },
    //       component: () => import('@/views/marketing/integral/addProduct/index.vue'),
    //     },
    //     {
    //       path: 'orderList',
    //       name: 'IntegralOrderList',
    //       meta: {
    //         title: '兑换记录',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/orderList/index.vue'),
    //     },
    //     {
    //       path: 'sign',
    //       name: 'signConfig',
    //       meta: {
    //         title: '签到配置',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/integral/sign/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'discounts',
    //   name: 'discounts',
    //   meta: {
    //     title: '套餐',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'discountsList',
    //       meta: {
    //         title: '套餐列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/discounts/index.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'atmosphere',
    //   name: 'atmosphere',
    //   meta: {
    //     title: '活动氛围',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'atmosphereList',
    //       meta: {
    //         title: '氛围列表',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/atmosphere/atmosphereList/index.vue'),
    //     },
    //     {
    //       path: 'add/:id?',
    //       name: 'addAtmosphere',
    //       meta: {
    //         title: '添加活动氛围',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/atmosphere/list`,
    //       },
    //       component: () => import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'border',
    //   name: 'border',
    //   meta: {
    //     title: '活动边框',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'borderList',
    //       meta: {
    //         title: '活动边框',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/border/borderList/index.vue'),
    //     },
    //     {
    //       path: 'add/:id?',
    //       name: 'addBorder',
    //       meta: {
    //         title: '添加活动边框',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/border/list`,
    //       },
    //       component: () => import('@/views/marketing/border/borderList/addBorder.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: 'application',
    //   name: 'Application',
    //   meta: {
    //     title: '活动报名',
    //     noCache: true,
    //   },
    //   redirect: 'noRedirect',
    //   component: ParentView,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'applicationList',
    //       meta: {
    //         title: '活动报名',
    //         noCache: true,
    //       },
    //       component: () => import('@/views/marketing/application/list/index.vue'),
    //     },
    //     {
    //       path: 'create',
    //       name: 'createApplication',
    //       meta: {
    //         title: '创建报名活动',
    //         noCache: true,
    //         activeMenu: `${roterPre}/marketing/application/list`,
    //       },
    //       component: () => import('@/views/marketing/application/list/create.vue'),
    //     },
    //   ],
    // },
  ],
};

export default marketingRouter;
